import { Controller } from "@hotwired/stimulus"

// 네이티브 <dialog> 로 여닫는 모달. Esc 는 브라우저가 닫아 준다.
// data-controller="dialog" 안에 data-dialog-target="dialog" 인 <dialog> 를 두고
// 여는 버튼에 data-action="dialog#open", 닫는 버튼에 data-action="dialog#close" 를 건다.
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    event?.preventDefault()
    this.dialogTarget.showModal()
  }

  close(event) {
    event?.preventDefault()
    this.dialogTarget.close()
  }

  // 바깥(배경)을 누르면 닫는다. 패널 안을 누른 것은 target 이 dialog 가 아니다.
  backdropClose(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }
}
